<template>
  <div>
    <market-group style="margin-top:40px;" v-show="group === 'a' || period.groups.indexOf(group) !== -1" v-for="(period, i) in periods" :key="i" :period="period.number" :kind="period.kind" :name="period.name">
      <market v-show="(group === 'a' || market.group === group) && market.name.toLowerCase().indexOf(query.toLowerCase()) !== -1" v-for="(market, j) in period.markets" :key="j" :team="market.team ? event[market.team] : null" :name="market.name">
        <div v-if="market.type === 'common'" class="factor-list" :class="{ ['factor-list__' + (market.size % 3 === 0 ? 3 : 2) + '-way']: true }">
          <factor-cell v-for="(f, k) in market.factors" :key="k" :factor="f" :event="period.event" :paused="event.paused" />
          <div class="empty-factor-cell" v-if="l >= market.factors.length" v-for="l in market.size - 1" :key="l"></div>
        </div>
        <div v-else-if="market.type === 'grid' || market.type === 'score'" :class="{ ['market-grid__' + market.size + '-way']: true }">
          <div class="market-col-names" v-if="market.type === 'score'">
            <div>{{ event.home }}</div>
            <div v-if="market.size === 3">{{ $t('factor-list.draw') }}</div>
            <div>{{ event.away }}</div>
          </div>
          <div class="factor-grid">
            <div class="factor-col" v-for="(col, k) in market.factors" :key="k">
              <factor-cell v-for="(f, l) in col" :key="l" :factor="f" :event="period.event" :paused="event.paused" />
              <div class="empty-factor-cell" v-if="l >= col.length" v-for="l in market.rows - 1" :key="l"></div>
            </div>
          </div>
        </div>
        <div v-else-if="market.type === 'specials'" class="specials-market-list" :class="{ ['specials-market-list__' + market.size + '-way']: true }">
          <div class="specials-market-row" v-for="(row, k) in market.factors" :key="k">
            <div class="specials-market-name" :title="row.name">{{ row.name }}</div>
            <factor-cell :factor="row.suite[0]" :event="period.event" :paused="event.paused" />
            <factor-cell :factor="row.suite[1]" :event="period.event" :paused="event.paused" />
            <factor-cell :factor="row.suite[2]" :event="period.event" :paused="event.paused" v-if="market.size === 3" />
          </div>
        </div>
      </market>
    </market-group>
    <!--market-group style="margin-top:40px;" v-show="group === 'a' || period.groups.indexOf(group) !== -1" v-for="(period, i) in periods" :key="i" :period="period.number" :kind="period.kind" :name="period.name">
      <market v-show="(group === 'a' || market.group === group) && market.name.toLowerCase().indexOf(query.toLowerCase()) !== -1" v-for="(market, j) in period.markets" :key="j" :team="market.team ? event[market.team] : null" :name="market.name">
        <div v-if="market.type === 'common'" class="factor-list" :class="{ ['factor-list__' + (market.size % 3 === 0 ? 3 : 2) + '-way']: true }">
          <factor-cell v-for="(f, k) in market.factors" :key="k" :factor="f" :event="period.event" :paused="false" />
          <div class="empty-factor-cell" v-if="l >= market.factors.length" v-for="l in market.size - 1" :key="l"></div>
        </div>
        <div v-else-if="market.type === 'grid' || market.type === 'score'" :class="{ ['market-grid__' + market.size + '-way']: true }">
          <div class="market-col-names" v-if="market.type === 'score'">
            <div>{{ event.home }}</div>
            <div v-if="market.size === 3">{{ $t('factor-list.draw') }}</div>
            <div>{{ event.away }}</div>
          </div>
          <div class="factor-grid">
            <div class="factor-col" v-for="(col, k) in market.factors" :key="k">
              <factor-cell v-for="(f, l) in col" :key="l" :factor="f" :event="period.event" :paused="false" />
              <div class="empty-factor-cell" v-if="l >= col.length" v-for="l in market.rows - 1" :key="l"></div>
            </div>
          </div>
        </div>
        <div v-else-if="market.type === 'specials'" class="specials-market-list" :class="{ ['specials-market-list__' + market.size + '-way']: true }">
          <div class="specials-market-row" v-for="(row, k) in market.factors" :key="k">
            <div class="specials-market-name" :title="row.name">{{ row.name }}</div>
            <factor-cell :factor="row.suite[0]" :event="period.event" :paused="false" />
            <factor-cell :factor="row.suite[1]" :event="period.event" :paused="false" />
            <factor-cell :factor="row.suite[2]" :event="period.event" :paused="false" v-if="market.size === 3" />
          </div>
        </div>
      </market>
    </market-group-->
  </div>
</template>

<script>
import MarketGroup from '@/components/sports/eventview/MarketGroup'
import Market from '@/components/sports/eventview/Market'
import FactorCell from '@/components/sports/eventview/FactorCell'

export default {
  components: { MarketGroup, Market, FactorCell },
  props: {
    periods: Array,
    event: Object,
    group: String,
    query: String
  }
}
</script>

<style scoped>
.factor-list { display: flex; flex-wrap: wrap; }
.factor-list > div { margin-top: 1px; }
.factor-list > div:first-child,
.factor-list > div:nth-child(2),
.factor-list__3-way > div:nth-child(3) { margin-top: 0; }
.factor-list > div:first-child { border-top-left-radius: 5px; }
.factor-list > div:last-child { border-bottom-right-radius: 5px; }
.factor-list__2-way > div:nth-child(odd) { width: 50%; }
.factor-list__3-way > div { flex-shrink: 0; width: 33%; }
.factor-list__2-way > div:nth-child(even),
.factor-list__3-way > div:nth-child(3n+2) { flex: 1 1; margin-left: 1px; }
.factor-list__3-way > div:nth-child(3n) { margin-left: 1px; }
.factor-list__2-way > div:nth-child(2),
.factor-list__3-way > div:nth-child(3) { border-top-right-radius: 5px; }
.factor-list__2-way > div:nth-last-child(2),
.factor-list__3-way > div:nth-last-child(3) { border-bottom-left-radius: 5px; }

.market-col-names { color: #342d6e; display: flex; height: 30px; line-height: 30px; margin-top: -10px; text-align: center; }
.market-col-names > div { flex-shrink: 0; }
.market-grid__2-way .market-col-names > div { width: 50%; }
.market-grid__3-way .market-col-names > div { width: 33%; }
.market-grid__2-way .market-col-names > div:last-child,
.market-grid__3-way .market-col-names > div:nth-child(2) { flex: 1 1; }
.factor-grid { display: flex; }
.factor-grid .factor-col { flex-shrink: 0; }
.factor-grid .factor-col:not(:first-child) { margin-left: 1px; }
.market-grid__2-way .factor-grid .factor-col { width: 50%; }
.market-grid__3-way .factor-grid .factor-col { width: 33%; }
.market-grid__2-way .factor-grid .factor-col:nth-child(even),
.market-grid__3-way .factor-grid .factor-col:nth-child(3n+2) { flex: 1 1; }
.factor-grid .factor-col > div:not(:first-child) { margin-top: 1px; }
.factor-grid .factor-col:first-child > div:first-child { border-top-left-radius: 5px; }
.factor-grid .factor-col:first-child > div:last-child { border-bottom-left-radius: 5px; }
.factor-grid .factor-col:last-child > div:first-child { border-top-right-radius: 5px; }
.factor-grid .factor-col:last-child > div:last-child { border-bottom-right-radius: 5px; }
.empty-factor-cell { background: rgba(255, 255, 255, .025); height: 30px; }

.specials-market-row { display: flex; }
.specials-market-list .specials-market-row:not(:first-child) { margin-top: 1px; }
.specials-market-row > div:not(:first-child) { margin-left: 1px; }
.specials-market-row > div:first-child { flex-shrink: 0; width: 50%; }
.specials-market-list__2-way .specials-market-row > div:nth-child(2) { flex: 1 1; }
.specials-market-row > div:last-child { flex-shrink: 0; width: 25%; }
.specials-market-list .specials-market-row:first-child > div:first-child { border-top-left-radius: 5px; }
.specials-market-list .specials-market-row:first-child > div:last-child { border-top-right-radius: 5px; }
.specials-market-list .specials-market-row:last-child > div:first-child { border-bottom-left-radius: 5px; }
.specials-market-list .specials-market-row:last-child > div:last-child { border-bottom-right-radius: 5px; }
.specials-market-list__3-way .specials-market-row > div:not(:last-child) { width: 25%; }
.specials-market-list__3-way .specials-market-row > div:last-child { flex: 1 1; }
.specials-market-name { background: rgba(255, 255, 255, .025); height: 30px; line-height: 30px; overflow: hidden; padding: 0 10px; text-overflow: ellipsis; white-space: nowrap; }
</style>



// WEBPACK FOOTER //
// src/components/sports/eventview/FactorList.vue